module.exports = __webpack_public_path__ + "static/media/Artboard10.0c5553ce.png";